import $ from 'jquery'
import Modal from 'bootstrap/js/src/modal'

export default class cannabisPrescriptionCustomPharmacyModal {
    constructor (element) {
        this.$element = $(element)
        this.$form = this.$element.find('form')
        this.$buttons = this.$element.find('.modal-footer [type=button]')
        this.$buttons.on('click', this.handleModalButtonClick.bind(this))
    }

    handleModalButtonClick (event) {
        event.preventDefault()
        const $target = $(event.target)
        const action = $target.data('action')
        switch (action) {
            case 'submit':
                this.$form.trigger('submit')
                break
            case 'cancel':
                // WIR MÜSSEN HIER DIE REFERENZ AUF DAS ADDTOCARTMODAL HABEN -> UM MIT IHM ZU KOMMUNIZIEREN!

        }
    }

    handleSubmit (event) {
        event.preventDefault()
        const ajaxSettings = {
            url: this.url,
            method: this.method,
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(this.getFormData()),
            headers: {}
        }

        this.$form.addClass('submitting')

        $.ajax(ajaxSettings)
            .done(this.handleRequestDone.bind(this))
            .fail(this.handleRequestFail.bind(this))
    }

    handleRequestDone (data, textStatus, jqXHR) {
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    handleRequestFail (jqXHR, textStatus, errorThrown) {
        let data = {}
        try {
            if (jqXHR.responseText) {
                data = JSON.parse(jqXHR.responseText)
            }
        } catch (e) {
            console.error(jqXHR.responseText)
        }
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    getFormData () {
        const indexedArray = {}
        const serializedArray = this.$form.serializeArray()
        // console.log('formData', serializedArray)

        $.map(serializedArray, function (n, i) {
            if (n['name'].endsWith('[]')) {
                const arrayName = n['name'].substr(0, n['name'].length - 2)
                if (!indexedArray.hasOwnProperty(arrayName)) {
                    indexedArray[arrayName] = []
                }
                indexedArray[arrayName].push(n['value'])
            } else {
                indexedArray[n['name']] = n['value']
            }
        })

        for (const serializer of this.customSerializer) {
            indexedArray[serializer.fieldName] = serializer.serialize()
        }

        return indexedArray
    }

    destroy () {

    }
}
